import { Tooltip, TooltipProps, Typography } from 'antd';
import { LinkProps } from 'antd/lib/typography/Link';
import { PropsWithChildren } from 'react';
type Props = PropsWithChildren<{
    toolTipProps?: TooltipProps;
    linkProps?: LinkProps;
    href: string;
    tooltipText: string;
}>;
export default function GrispiTooltipLink({ toolTipProps, linkProps, href, tooltipText, children }: Props) {
    return (
        <Tooltip placement="bottom" {...toolTipProps} title={tooltipText}>
            <Typography.Link strong target="_blank" rel="noopener noreferrer" {...linkProps} href={href}>
                {children}
            </Typography.Link>
        </Tooltip>
    );
}
